var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartnerMore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 50 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 7
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2649",
    cx: 11,
    cy: 7,
    r: 2,
    fill: "var(--fill-0, #636363)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2650",
    cx: 20,
    cy: 7,
    r: 2,
    fill: "var(--fill-0, #636363)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2651",
    cx: 29,
    cy: 7,
    r: 2,
    fill: "var(--fill-0, #636363)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerMore);
export default __webpack_public_path__ + "static/media/PartnerMore.cbfb67508e03cfc8a41fb441a79774ef.svg";
export { ForwardRef as ReactComponent };